import React, {Fragment} from 'react';
import {Link} from 'gatsby';
import './styles.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Translate} from '../../translations';
import {faFacebookF, faYoutube, faTwitter, faLinkedin, faInstagram} from '@fortawesome/free-brands-svg-icons';
import chromeIcon from '../../../images/chrome.svg';
import firefoxIcon from '../../../images/firefox.svg';

const footerMenuItems = [
  {
    name: 'Menu',
    subItems: [
      {name: 'Why Hexospark', linkTo: '/why-hexospark'},
      {name: 'Pricing', linkTo: '/pricing'},
      {name: 'FAQ', linkTo: '/faq'},
      {name: 'Academy', linkTo: 'https://hexospark.com/academy/', target: '_blank', ariaLabel: 'hexofy blog'},
      {
        name: 'Tutorials',
        linkTo: 'https://hexospark.com/academy/hexospark-tutorials/',
        target: '_blank',
        ariaLabel: 'hexofy blog',
      },
      {
        name: 'Changelog',
        linkTo: 'https://hexospark.com/academy/changelog/',
        target: '_blank',
        ariaLabel: 'hexofy blog',
      },
      {name: 'Contact us', linkTo: '/contact'},
    ],
  },
];

const Footer = () => {
  return (
    <footer className="footer_area footer_area_five f_bg" id="footer">
      <div className="footer_chat">
        <div className="container">
          <h2 className="f_p f_size_14 t_color f_400 l_height30 d-flex mb-0 flex-wrap">
            <div className="f_p f_size_20 f_600 t_color pr_20">
              <Translate name="FOOTER_UPPER_TEXT_LEFT" />
            </div>
            Email to &nbsp;
            <a href="mailto:support@hexofy.com" aria-label={'mail'} target="_blank" rel="noreferrer noopener">
              support@hexofy.com
            </a>
          </h2>
        </div>
      </div>
      <div className="footer_top sec_pad">
        <div className="container">
          <div className="d-flex flex-wrap m-0">
            <div className="my-auto mx-auto mx-xl-0">
              <div className="f_widget company_widget">
                <div className="widget-wrap d-block d-sm-flex">
                  {/* <p>Hexofy makes it easy to scrape data from any website with a simple browser extension.</p> */}
                  <Link to="/faq" className="footer-menu-item mr-2 d-block">
                    FAQ
                  </Link>
                  <a href="https://hexofy.com/academy" className="footer-menu-item mx-2 d-block">
                    Academy
                  </a>
                  <a href="https://hexofy.com/academy/hexofy-tutorials" className="footer-menu-item mx-2 d-block">
                    Tutorials
                  </a>
                  <a href="https://hexofy.com/academy/changelog" className="footer-menu-item mx-2 d-block">
                    Changelog
                  </a>
                  <Link to="/contact" className="footer-menu-item mx-2 d-block">
                    Contact us
                  </Link>
                </div>
              </div>
            </div>

            <div className="d-flex mx-auto mr-xl-0 ml-xl-auto">
              <div className="f_widget social_widget m-auto">
                <div className="footer-extensions d-flex">
                  <a
                    aria-label="Hexofy Chrome extension"
                    href="https://chromewebstore.google.com/detail/hexofy-scraper-free-web-s/bmcfkceaciejniimbpekgcgkodlgfadj"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <img src={chromeIcon} width="160px" alt="Hexofy Chrome extension" className="extension-badge" />
                  </a>
                  <a
                    aria-label="Hexofy Firefox add-on"
                    href="https://addons.mozilla.org/en-US/firefox/addon/hexofy/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <img src={firefoxIcon} width="160px" alt="Hexofy Firefox add-on" className="extension-badge" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_bottom">
        <div className="container">
          <div className="d-xl-flex align-center text-center justify-content-between">
            <div className="">
              &copy; {new Date().getFullYear()} Hexact, Inc. All rights reserved. 1250 E. Hallandale Beach Blvd., Unit 808,
              Hallandale Beach, Florida 33009
            </div>
            <div className="">
              <ul className="list-unstyled f_menu text-right">
                {/* <li>
                  <Link to="/faq">FAQ</Link>
                </li> */}
                {/* <li>
                  <Link to="/contact">Contact us</Link>
                </li> */}
                <li>
                  <Link to="/terms-of-use">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/cookie-policy">Cookie Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
